import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/components/components.module';
import { PipesModule } from 'src/app/pipes/pipe.module';
import { DocumentViewerModal } from './document-viewer.modal';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

@NgModule({
    declarations: [
        DocumentViewerModal
    ],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        IonicModule,
        ComponentsModule,
        PipesModule,
        ReactiveFormsModule,
        NgxDocViewerModule
    ]
})
export class DocumentViewerModalModule { }
